import {handleSend, handleFileSend} from '../handleSend'
import {CommonApi} from '../common_api'

export const PersonApi = {
  // 查询部门树
  queryDepartmentTree () {
    return CommonApi.getTreeList('02', '1', '')
  },
  // 查询机构树
  queryInstitutionTree () {
    return CommonApi.getTreeList('01', '0', '')
  },
  // 查询部门列表
  queryDepartmentList (data, isDesensit = 'true') {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '30', '0002', '0', 'message', isDesensit)
  },
  // 新增/修改部门信息
  handleDepartment (data, type = 0) {
    return handleSend(data, '30', '0001', String(type))
  },
  // 删除部门信息
  deleteDepartment (data) {
    return handleSend(data, '30', '0003')
  },
  // 查询正常人员信息列表
  queryNormalPersonList (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '31', '0000', String(type), 'message')
  },
  // 查询人员信息列表
  queryPersonInfoList (data, type = 0, isDesensit = 'true') {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '31', '0002', String(type), 'message', isDesensit)
  },
  // 新增/修改人员信息
  handlePersonInfo (data, type = 0) {
    return handleSend(data, '31', '0001', String(type))
  },
  // 批量导入人员信息(存入临时表)
  batchCreatePersonInfo (data, content, fileType = '0') {
    let fd = new FormData() // FormData 对象
    fd.append('file', data) // 文件对象
    fd.append('fileType', fileType)
    fd.append('content', content)
    fd.append('AppCode', '31')
    fd.append('BizCode', '0003')
    return handleFileSend('/uploadFiles', '31', '0003', fd, 'Alert')
  },
  // 批量导入人员信息查询(临时表)
  batchQueryPersonInfo (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '31', '0011', '0', 'message')
  },
  // 批量导入人员信息确认(存入人员表)
  batchConfirmPersonInfo (data) {
    return handleSend(data, '31', '0009')
  },
  // 冻结/解冻人员信息(0-冻结、1-解冻)
  freezeOrThawPersonInfo (data, type = 0) {
    return handleSend(data, '31', '0004', String(type))
  },
  // 注销人员信息（0-单个注销、1-按部门注销）----废弃接口
  // deletePersonInfo (data, type = 0) {
  //   return handleSend(data, '31', '0005', String(type))
  // },
  // 个人预注销接口（31,1001
  preLogoffPerson (data) {
    return handleSend(data, '31', '1001')
  },
  // 个人注销接口（31,1002
  logoffPerson (data) {
    return handleSend(data, '31', '1002')
  },
  // 部门人员预注销接口（31,1003
  preLogoffDepartment (data) {
    return handleSend(data, '31', '1003')
  },
  // 部门人员身份注销接口（31,1004
  logoffDepartment (data) {
    return handleSend(data, '31', '1004')
  },
  // 批量导入注销人员信息(存入临时表)
  batchDeletePersonInfo (data) {
    let fd = new FormData() // FormData 对象
    fd.append('file', data) // 文件对象
    fd.append('fileType', '0')
    fd.append('content', '0')
    fd.append('AppCode', '31')
    fd.append('BizCode', '0006')
    return handleFileSend('/uploadFiles', '31', '0006', fd, 'Alert')
  },
  // 批量导入注销人员信息确认
  confirmBatchDeleteInfo (data) {
    return handleSend(data, '31', '0010')
  },
  // 获取人员照片
  getPersonPhoto (data) {
    return handleSend(data, '31', '0007')
  },
  // 批量上传人员照片
  batchUploadPersonPicture (data, content = '0') {
    let fd = new FormData() // FormData 对象
    data.forEach((file) => {
      fd.append('file', file.raw)
    })
    // fd.append('file', data) // 文件对象
    fd.append('fileType', '0')
    fd.append('content', content)
    fd.append('AppCode', '31')
    fd.append('BizCode', '0008')
    return handleFileSend('/uploadFiles', '31', '0008', fd, 'Alert')
  },
  // 查询人脸信息列表
  queryHumanFaceInfoList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '32', '0001', '0', 'message')
  },
  // 修改人脸信息(0-修改有效期、1-停用、2-启用、9-废除)
  handleHumanFaceInfo (data, type = 0) {
    return handleSend(data, '32', '0002', String(type))
  },
  // 删除人脸信息
  deleteHumanFaceInfo (data) {
    return handleSend(data, '32', '0006')
  },
  // 人脸采集
  uploadHumanFace (data) {
    // let config = {
    //   headers: {
    //     'Content-Type': 'multipart/form-data'
    //   }
    // }
    // let fd = new FormData() // FormData 对象
    // fd.append('personid', id)
    // fd.append('imginfo', data) // 文件对象
    // // fd.append('fileType', '0')
    // // fd.append('content', '0')
    // fd.append('AppCode', '32')
    // fd.append('BizCode', '0003')
    // fd.append('token', store.state.token)
    // return post('/uploadFiles', fd, 'Alert', config)
    return handleSend(data, '32', '0003')
  },
  // 批量评估人脸照片(返回评估结果)
  evaluateHumanFace (data) {
    let fd = new FormData() // FormData 对象
    fd.append('file', data) // 文件对象
    fd.append('fileType', '0')
    fd.append('content', '0')
    fd.append('AppCode', '32')
    fd.append('BizCode', '0004')
    return handleFileSend('/uploadFiles', '32', '0004', fd, 'Alert')
  },
  // 批量上传人脸照片
  batchUploadHumanFace (data) {
    let fd = new FormData() // FormData 对象
    data.forEach((file) => {
      fd.append('file', file.raw)
    })
    // fd.append('file', data) // 文件对象
    fd.append('fileType', '0')
    fd.append('content', '')
    fd.append('AppCode', '32')
    fd.append('BizCode', '0004')
    return handleFileSend('/uploadFiles', '32', '0004', fd, 'Alert')
  },
  // 人脸下载失败记录查询
  queryHumanFaceDownLoadFaild (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '32', '0005', '0', 'message')
  },
  // 查询介质管理流水
  queryMediaChangeRecord (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '32', '4001', '0', 'message')
  },
  // 查询二维码信息列表
  queryQRCodeInfoList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '32', '3001', '0', 'message')
  },
  // 修改二维码有效期
  updateRQCodeExpiredt (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '32', '3002', '0', 'message')
  },
  // 查询人员介质
  queryPersonMedia (data) {
    return handleSend(data, '31', '0013', '0', 'message')
  }
}



// WEBPACK FOOTER //
// ./src/request/ApplyBasic/dept_person_api.js